import React, { useEffect, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useTransition, animated } from 'react-spring';
import { FaArrowCircleUp, FaAngleDoubleLeft, FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import NavbarDetailBlog from '../../../components/navbarDetailBlog.tsx';
import HeaderDetailBlog from '../utils/headerDetailBlog.tsx';
import Footer from '../../../components/footer.tsx';
import { Link } from 'react-router-dom';
import ImageModal from '../utils/imageModal.tsx';


import usePreventZoom from '../../../preventZoom.js';

import Header from '../../../assets/Blog/ACL/ACL_PART5/Detail/HEADER_DETAIL_ACL_PART5.webp';
import Pict1 from "../../../assets/Blog/ACL/ACL_PART5/Detail/1.webp";
import Pict2 from "../../../assets/Blog/ACL/ACL_PART5/Detail/2.webp";
import Pict3 from "../../../assets/Blog/ACL/ACL_PART5/Detail/3.webp";
import Pict4 from "../../../assets/Blog/ACL/ACL_PART5/Detail/4.webp";

import Gallery1 from "../../../assets/Blog/ACL/ACL_PART5/Detail/5.webp";
import Gallery2 from "../../../assets/Blog/ACL/ACL_PART5/Detail/6.webp";
import Gallery3 from "../../../assets/Blog/ACL/ACL_PART5/Detail/7.webp";
import Gallery4 from "../../../assets/Blog/ACL/ACL_PART5/Detail/8.webp";
import Gallery5 from "../../../assets/Blog/ACL/ACL_PART5/Detail/9.webp";
import Gallery6 from "../../../assets/Blog/ACL/ACL_PART5/Detail/10.webp";
import Gallery7 from "../../../assets/Blog/ACL/ACL_PART5/Detail/11.webp";
import Gallery8 from "../../../assets/Blog/ACL/ACL_PART5/Detail/12.webp";
import Gallery9 from "../../../assets/Blog/ACL/ACL_PART5/Detail/13.webp";
import Gallery10 from "../../../assets/Blog/ACL/ACL_PART5/Detail/14.webp";
import Gallery11 from "../../../assets/Blog/ACL/ACL_PART5/Detail/15.webp";
import Gallery12 from "../../../assets/Blog/ACL/ACL_PART5/Detail/16.webp";
import Gallery13 from "../../../assets/Blog/ACL/ACL_PART5/Detail/17.webp";
import Gallery14 from "../../../assets/Blog/ACL/ACL_PART5/Detail/18.webp";
import Gallery15 from "../../../assets/Blog/ACL/ACL_PART5/Detail/19.webp";
import Gallery16 from "../../../assets/Blog/ACL/ACL_PART5/Detail/20.webp";
import Gallery17 from "../../../assets/Blog/ACL/ACL_PART5/Detail/21.webp";
import Gallery18 from "../../../assets/Blog/ACL/ACL_PART5/Detail/22.webp";
import Gallery19 from "../../../assets/Blog/ACL/ACL_PART5/Detail/23.webp";
import Gallery20 from "../../../assets/Blog/ACL/ACL_PART5/Detail/24.webp";
import Gallery21 from "../../../assets/Blog/ACL/ACL_PART5/Detail/25.webp";
import Gallery22 from "../../../assets/Blog/ACL/ACL_PART5/Detail/26.webp";
import Gallery23 from "../../../assets/Blog/ACL/ACL_PART5/Detail/27.webp";
import Gallery24 from "../../../assets/Blog/ACL/ACL_PART5/Detail/28.webp";
import Gallery25 from "../../../assets/Blog/ACL/ACL_PART5/Detail/29.webp";
import Gallery26 from "../../../assets/Blog/ACL/ACL_PART5/Detail/30.webp";
import Gallery27 from "../../../assets/Blog/ACL/ACL_PART5/Detail/31.webp";

import CommentListExample from '../../../components/comments/commentListExample.tsx';

const ACLPART5: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 900px)').matches);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedAlt, setSelectedAlt] = useState('');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(30);
        setTimeout(() => {
            setProgress(100);
        }, 600);
    }, []);
  
    const openModal = (imageUrl, imageAlt) => {
        setSelectedImage(imageUrl);
        setSelectedAlt(imageAlt);
        setModalVisible(true);
    };
  
    const closeModal = () => {
        setSelectedImage('');
        setSelectedAlt('');
        setModalVisible(false);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 900px)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 350) {
            setShowScrollToTop(true);
        } else {
            setShowScrollToTop(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const arrowTransition = useTransition(showScrollToTop, {
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(100%)' },
        config: { tension: 300, friction: 20 },
      });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: false});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    usePreventZoom();

    return(
        <div className='App'>
            <NavbarDetailBlog/>
            <div className='pt-20 min-w-screen font-condensed text-textGrey'>
                {/* Loading Bar */}
                <LoadingBar color="#8C001f" progress={progress} onLoaderFinished={() => setProgress(0)} />
                <section className='hidden w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'>
                        <script type='text/javascript' id='mapmyvisitors' src='https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff'></script>
                </section>
                <HeaderDetailBlog backgroundImage={Header} title="Day 4 ACL – Diversity & Inclusion Lunch (Part 5)" date="31" year="July, 2025" backgroundPosition="center center"></HeaderDetailBlog>
                <div className='author-article text-end pr-4 pt-8 pb-4 text-xs'>
                    <p className='font-condensed text-textGrey'>by Mohammad Rifqi Farhansyah | Association for Computational Linguistics 2025</p>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict1, 'A photo of me while serving as a volunteer (please ignore my face).')}>
                            <img
                                src={Pict1}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of me while serving as a volunteer (please ignore my face)."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of me while serving as a volunteer (please ignore my face).</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Austria Center Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-2xl'>Today is my chance to build connections through the various community events I will be attending.</p>
                        <br/>
                        <p className='text-lg'>
                            On July 31, I was assigned as a volunteer for the morning poster session. This session felt much quieter, probably because it was no longer part of the Main Conference, but workshops poster sessions instead. So my job was relatively light. I only helped a few people set up their posters, and sometimes, since they already knew what to do, they did not even ask for help. Because of that, I spent more time walking around, looking for papers that caught my interest, listening to presenters, and asking questions here and there. At that time, I found several papers that aligned well with my next research direction, especially around LLMs for healthcare systems. I spent quite some time digging into a paper presented by a Google team, and it turned out to be really helpful for my future paper.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict2, 'A photo of Kak Lucky explaining his work to an Indonesian colleague (an ITS alumnus).')}>
                            <img
                                src={Pict2}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of Kak Lucky explaining his work to an Indonesian colleague (an ITS alumnus)."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of Kak Lucky explaining his work to an Indonesian colleague (an ITS alumnus).</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Austria Center Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            During the same session, Kak Lucky was presenting his paper on hate speech. I listened to his explanation a few times. Suddenly, a woman wearing a hijab came by, and she looked Indonesian or Malaysian. I asked her directly, and it turned out she was Indonesian. She studied at ITS before and is currently continuing her studies in Japan. She then listened to Kak Lucky’s explanation about his hate speech paper.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        A more relaxed day.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Header})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict3, 'SEA-VL merchandise from SeaCrowd.')}>
                            <img
                                src={Pict3}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="SEA-VL merchandise from SeaCrowd."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>SEA-VL merchandise from SeaCrowd.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Austria Center Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            At noon, there was a Birds of a Feather session organized by SeaCrowd. If you remember my second paper about the SEA vision-language dataset, it was initiated by this non-profit organization. Many researchers from Southeast Asia are part of this initiative. There, I met many colleagues and seniors in NLP research. I was also given some merchandise, a T-shirt, because I became a Major Contributor to the SEA-VL paper. We talked a lot during that session, discussing the future of AI research in Southeast Asia and many other things. Unfortunately, I could not stay too long because I had to attend another agenda.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict4, 'A photo of Kak Iwan and me with Pascale Fung (Meta).')}>
                            <img
                                src={Pict4}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="A photo of Kak Iwan and me with Pascale Fung (Meta)."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>A photo of Kak Iwan and me with Pascale Fung (Meta).</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Austria Center Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            The next agenda I attended was a lunch with the recipients of the Diversity & Inclusion Grant from Apple. There were 10 recipients from all over the world, and two of them were Kak Iwan and me. I received funding support for travel, flight tickets, and hotel, totaling around 1400 USD. As far as I know, this grant prioritizes undergraduate students, people from developing countries, first-time ACL attendees, or those with financial limitations. During the lunch, we were served really good food. We also met senior figures in ACL. It felt like 10 ACL newbies meeting 10 of the most senior and influential people in ACL.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            One of the seniors who really caught my attention was Pascale Fung, a researcher at Meta. She used to be a professor at HKUST. During her time there, she supervised many students from Indonesia, including some of my seniors like Kak Genta, Kak Samuel, and Kak Holy. It turns out her mother is from Bandung, Indonesia, which explains why she took many Indonesian students, especially from Institut Teknologi Bandung. I asked her about PhD opportunities with her at HKUST, but unfortunately, she is no longer accepting new students. That was really a pity. FYI, I am currently looking for PhD opportunities, so if any professor reading this is looking for students in areas like multilingualism, low-resource languages, and related topics, please feel free to reach out, HEHEHE.
                        </p>
                        <div className='article-break-1 flex justify-start items-center flex-col'>
                            <hr className='w-full mt-4 mb-4  border-t border-b border-solid'/>
                        </div>
                        <p className='text-lg font-bold'><i>to be continued...</i></p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-8 mb-4'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                            There are so many communities here, and all of them are helping me grow.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery1, "Photo Recap: Day 4 ACL (Part 1).")}>
                        <img
                            src={Gallery1}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 1)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 1).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery2, "Photo Recap: Day 4 ACL (Part 2).")}>
                        <img
                            src={Gallery2}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 2)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 2).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery3, "Photo Recap: Day 4 ACL (Part 3).")}>
                        <img
                            src={Gallery3}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 3)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 3).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery4, "Photo Recap: Day 4 ACL (Part 4).")}>
                        <img
                            src={Gallery4}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 4)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 4).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery5, "Photo Recap: Day 4 ACL (Part 5).")}>
                        <img
                            src={Gallery5}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 5)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 5).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery6, "Photo Recap: Day 4 ACL (Part 6).")}>
                        <img
                            src={Gallery6}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 6)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 6).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery7, "Photo Recap: Day 4 ACL (Part 7).")}>
                        <img
                            src={Gallery7}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 7)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 7).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery8, "Photo Recap: Day 4 ACL (Part 8).")}>
                        <img
                            src={Gallery8}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 8)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 8).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery9, "Photo Recap: Day 4 ACL (Part 9).")}>
                        <img
                            src={Gallery9}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 9)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 9).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery10, "Photo Recap: Day 4 ACL (Part 10).")}>
                        <img
                            src={Gallery10}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 10)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 10).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery11, "Photo Recap: Day 4 ACL (Part 11).")}>
                        <img
                            src={Gallery11}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 11)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 11).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery12, "Photo Recap: Day 4 ACL (Part 12).")}>
                        <img
                            src={Gallery12}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 12)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 12).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery13, "Photo Recap: Day 4 ACL (Part 13).")}>
                        <img
                            src={Gallery13}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 13)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 13).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery14, "Photo Recap: Day 4 ACL (Part 14).")}>
                        <img
                            src={Gallery14}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 14)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 14).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery15, "Photo Recap: Day 4 ACL (Part 15).")}>
                        <img
                            src={Gallery15}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 15)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 15).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery16, "Photo Recap: Day 4 ACL (Part 16).")}>
                        <img
                            src={Gallery16}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 16)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 16).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery17, "Photo Recap: Day 4 ACL (Part 17).")}>
                        <img
                            src={Gallery17}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 17)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 17).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery18, "Photo Recap: Day 4 ACL (Part 18).")}>
                        <img
                            src={Gallery18}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 18)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 18).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery19, "Photo Recap: Day 4 ACL (Part 19).")}>
                        <img
                            src={Gallery19}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 19)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 19).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery20, "Photo Recap: Day 4 ACL (Part 20).")}>
                        <img
                            src={Gallery20}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 20)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 20).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery21, "Photo Recap: Day 4 ACL (Part 21).")}>
                        <img
                            src={Gallery21}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 21)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 21).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery22, "Photo Recap: Day 4 ACL (Part 22).")}>
                        <img
                            src={Gallery22}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 22)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 22).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery23, "Photo Recap: Day 4 ACL (Part 23).")}>
                        <img
                            src={Gallery23}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 23)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 23).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery24, "Photo Recap: Day 4 ACL (Part 24).")}>
                        <img
                            src={Gallery24}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 24)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 24).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery25, "Photo Recap: Day 4 ACL (Part 25).")}>
                        <img
                            src={Gallery25}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 25)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 25).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery26, "Photo Recap: Day 4 ACL (Part 26).")}>
                        <img
                            src={Gallery26}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 26)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 26).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery27, "Photo Recap: Day 4 ACL (Part 27).")}>
                        <img
                            src={Gallery27}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Day 4 ACL (Part 27)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Day 4 ACL (Part 27).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center px-12 md:mb-8 mb-4 gap-x-8'>
                <Link to="/acl/acl-part4" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    <FaAngleDoubleLeft className='w-3 h-3 text-textRed inline-block mr-1' />
                    PREV 
                </Link>
                <Link to="/acl/acl-part6" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    NEXT 
                    <FaAngleDoubleRight className='w-3 h-3 text-textRed inline-block ml-1' />
                </Link>
            </div>
            <div className='bg-fixed w-full h-96' style={{ backgroundImage: `url(${Pict4})`, backgroundSize: 'cover',  }}>
            </div>
            <CommentListExample postId={5} seriesId={2}/>
            <ImageModal
                showModal={modalVisible}
                closeModal={closeModal}
                imageUrl={selectedImage}
                imageAlt={selectedAlt}
            />
            <Footer/>
            {arrowTransition((style, item) =>
                item ? (
                <animated.div
                    style={style}
                    className="fixed bottom-5 right-5 cursor-pointer z-10"
                    onClick={scrollToTop}
                >
                    <FaArrowCircleUp
                    size={isMd ? 32 : 24}
                    className="text-[#c0c5ca] hover:scale-110"
                    />
                </animated.div>
                ) : null
            )}
        </div>
    );
};

export default ACLPART5